import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { Link, useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Button, Card, CardBody, CardHeader, Col, Container, FormInput, FormSelect, Row } from 'shards-react'
import { GeneralSettingsKeys, NavgationPageLocationKey } from '../../../utils/constants';
import { formatNumberAmount } from '../../../utils/general';
import { setDateForTable } from '../../../utils/date';
import CustomVerticalStepper from '../../../components/common/VerticalStepper';
import { setAlert } from '../../../redux/actions/alert';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { download_payment_instruction, get_client_bank_details, get_client_calculate_invoice_payment, get_client_currency_list, get_client_invoice_payment, reset_client_invoice_payment_details, save_client_invoice_payments } from '../../../redux/actions/client/clientInvoice';
import { get_sub_config } from '../../../redux/actions/user';

const ClientPayment = ({ get_client_currency_list, setAlert
    , get_client_calculate_invoice_payment, invoicePaymentCalculation
    , get_client_invoice_payment, invoiceCurrencyList
    , download_payment_instruction, save_client_invoice_payments
    , paymentInvoice, savedInvoicePayment, reset_client_invoice_payment_details
    , clientBankDetails, get_client_bank_details
}) => {
    const location = useLocation();
    const [refNum, setrefNum] = useState(0);
    const history = useHistory();
    const [activeStep, setActiveStep] = useState(0);

    //Timer
    const [timerKey, setTimerKey] = useState(0);
    const currentTime = useRef(null);
    const prevTime = useRef(null);
    const isNewTimeFirstTick = useRef(false);
    const [, setOneLastRerender] = useState(0);
    const [isTimeUp, setIsTimeUp] = useState(false); // tracks when time hits 0

    const [sessionValue, setSessionValue] = useState({
        balanceDue: 0,
        currency: '',
        dueDate: '',
        invoiceAmount: 0,
        refNum: 0,
        invoiceRefNum: 0,
        clientName: '',
    });
    const [initialState, setInitialState] = useState({
        refNum: refNum,
        invoiceRefNum: 0,
        // clientName: "",
        currency: '',
        invoiceAmount: 0,
        paymentAmount: 0,
        fxRate: 0,
        balanceDue: 0,
        expiryDate: '',
        paymentDate: '',
    })

    const [bankDetails, setBankDetails] = useState({
        recipientName: '',
        address: '',
        bankName: '',
        bankAddress: '',
        bankAccount: '',
        routing: '',
        instructionsSteps: [],
    });
    const [formData, setFormData] = useState(initialState)
    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }
    const workerListOptins = invoiceCurrencyList?.map(inv => <option key={inv.currencyId + '_' + inv.currencyCode} value={inv.currencyCode}>{inv.currencyCode}</option>)

    const onContinue = (e) => {
        e.preventDefault();
        if (formData.currency !== "") {
            setActiveStep(1);
            //Need to make an API call here
            let currencyId = invoiceCurrencyList?.filter((x) => { return x.currencyCode === formData.currency})[0]?.currencyId;
            get_client_calculate_invoice_payment(sessionValue.invoiceRefNum, currencyId, 0);
        }
        else {
            setAlert("Please select Payment Currency", 'danger');
            return false;
        }
        //Initialize step #2
    }

    const paymentAmountContinue = async (e) => {
        e.preventDefault();
        //Call SAVE INVOICE PAYMENT
        let currencyId = invoiceCurrencyList?.filter((x) => { return x.currencyCode === formData.currency})[0]?.currencyId;
        let saveObject = { invoiceRefNum: sessionValue.invoiceRefNum
            , paymentCurrencyId: currencyId
            , paymentAmount: formData.paymentAmount
        }
        let ret = await save_client_invoice_payments(saveObject);
        if(ret){
            setActiveStep(2);
        }
    }

    const completePayment = (e) => {
        e.preventDefault();
        let paymentState = { 
            clientName: sessionValue.clientName
            , customerId: 'CUST-00001'
            //, refNum: refNum
            //, refNum: sessionValue.invoiceRefNum
            , invoiceRefNum: sessionValue.invoiceRefNum
            , refNum: refNum === 0 ? formData.refNum : refNum
            , currency: formData.currency
            , paymentAmount: formData.paymentAmount 
        };

        localStorage.setItem(NavgationPageLocationKey.clientPaymentGateway, JSON.stringify(paymentState));
        window.open('/client-payment-gateway', '_blank');
        //Can we open in new tab lets check
        // history.push({
        //     pathname: `/client-payment-gateway`,
        //     state: { paymentState }
        // });
    }

    const downloadInstruction = (e) => {
        e.preventDefault();
        //download_payment_instruction(refNum);
        download_payment_instruction(refNum === 0 ? formData.refNum : refNum);
    }

    const handleRestart = () => {
        if(activeStep === 1) {
            let currencyId = invoiceCurrencyList?.filter((x) => { return x.currencyCode === formData.currency})[0]?.currencyId;
            get_client_calculate_invoice_payment(sessionValue.invoiceRefNum , currencyId, formData.paymentAmount);
        }
    };

    // useEffect to show alert once
    useEffect(() => {
        if (isTimeUp) {
            //call an API
            setIsTimeUp(!isTimeUp);
            handleRestart()
        }
    }, [isTimeUp]);

    useEffect(() => {
        if(activeStep === 1) {
            let currencyId = invoiceCurrencyList?.filter((x) => { return x.currencyCode === formData.currency})[0]?.currencyId;
            //get_client_calculate_invoice_payment(refNum, currencyId);
            get_client_calculate_invoice_payment(sessionValue.invoiceRefNum, currencyId, formData.paymentAmount);
        }
    }, [timerKey])

    const formatTime = (remainingTime) => {
        const minutes = String(Math.floor(remainingTime / 60)).padStart(2, '0');
        const seconds = String(remainingTime % 60).padStart(2, '0');
        return `${minutes}:${seconds}`;
    };

    const renderTime = ({ remainingTime }) => {
        if (currentTime.current !== remainingTime) {
            isNewTimeFirstTick.current = true;
            prevTime.current = currentTime.current;
            currentTime.current = remainingTime;
        } else {
            isNewTimeFirstTick.current = false;
        }

        // force one last re-render when the time is over to tirgger the last animation
        if (remainingTime === 0) {
            setTimeout(() => {
                setOneLastRerender((val) => val + 1);
                //setIsTimeUp(true);
            }, 20);
        }

        const isTimeUp = isNewTimeFirstTick.current;

        return (
            <div className="time-wrapper" style={{ fontSize: "18px" }}>
                <div key={remainingTime} className={`time ${isTimeUp ? "up" : ""}`}>
                    {formatTime(remainingTime)}
                    {/* 00 : {remainingTime} */}
                </div>
                {prevTime.current !== null && (
                    <div
                        key={prevTime.current}
                        className={`time ${!isTimeUp ? "down" : ""}`}
                    >
                        {prevTime.current}
                    </div>
                )}
            </div>
        );
    };

    const onFocusOutPaymentAmount = async (e) => {
        e.preventDefault();
        // calll an api
        let currencyId = invoiceCurrencyList?.filter((x) => { return x.currencyCode === formData.currency})[0]?.currencyId;
        get_client_calculate_invoice_payment(sessionValue.invoiceRefNum, currencyId, formData.paymentAmount);
    }

    const step1 = <>
        <div>
            <div>
                Step 1 - Choose a Payment Currency
            </div>
            <hr></hr>
            <Row>
                <Col lg="7" className="form-group p-2 m-0">
                    <div className="d-flex flex-row justify-content-between">
                        <label>Payment Currency: </label>
                    </div>
                    <div className="d-flex flex-row justify-content-between">
                        <FormSelect value={formData.currency} onChange={onChange}
                            id="currency" name="currency" required>
                            <option value=''>Select Payment Currency</option>
                            {workerListOptins}
                        </FormSelect>
                    </div>
                    <div className='mt-3 custom-textalign-center'>
                        <Button onClick={onContinue}>Continue</Button>
                    </div>
                </Col>
            </Row>
        </div>
    </>;

    const step2 = <>
        <div>
            <div>
                Confirm Payment Amount
            </div>
            <div className='fontWeight400'>
                <span>
                    Confirming this amount will lock in the exchange rate. This cannot be changed later.
                </span>
            </div>
            <hr></hr>
            <Row>
                <Col lg="9" className="form-group pr-5">
                    <Row className="ml-2">
                        <Col lg="5" className="form-group my-auto pt-2">
                            <label htmlFor="paymentAmount" className="font-weight-bold">Payment Amount</label>
                        </Col>
                        <Col lg="7" className="form-group my-auto d-flex">
                            <FormInput value={formData.paymentAmount} onChange={onChange}
                                id="paymentAmount" name="paymentAmount" onBlur={onFocusOutPaymentAmount}>
                            </FormInput>
                            <span className='p-2'> {formData.currency} </span>
                        </Col>
                    </Row>
                    <Row className="ml-2">
                        <Col lg="5" className="form-group my-auto pt-2">
                            <label className="">Payment Amount in:</label>
                            <label className="">Invoice Currency</label>
                        </Col>
                        <Col lg="7" className="form-group my-auto d-flex">
                            <label className='p-2'>

                                {/* $ {formatNumberAmount(sessionValue.balanceDue, 'en-US', 2)} */}
                                $ {formatNumberAmount(formData.balanceDue, 'en-US', 2, 2)}
                            </label>
                            <label className='p-2'> {sessionValue.currency} </label>
                        </Col>
                    </Row>

                    <Row className="ml-2">
                        <Col lg="5" className="form-group my-auto pt-2">
                            <label htmlFor="fxRate" className="">FX Rate:</label>
                        </Col>
                        <Col lg="7" className="form-group my-auto d-flex">
                            <label className='p-2'>
                                {formatNumberAmount(formData.fxRate, 'en-US', 5, 5)}
                            </label>
                        </Col>
                    </Row>

                    <Row className="ml-2">
                        <Col lg="5" className="form-group my-auto pt-2">
                            <label className="">Expires in:</label>
                        </Col>
                        <Col lg="7" className="form-group my-auto d-flex">
                            <div className='timer-wrapper'>
                                <CountdownCircleTimer
                                    key={timerKey}
                                    isPlaying
                                    duration={60}
                                    size={80}
                                    strokeWidth={6}
                                    colors={["#004777", "#F7B801", "#A30000", "#A30000"]}
                                    colorsTime={[10, 6, 3, 0]}
                                    onComplete={() => {
                                        handleRestart()
                                        return { shouldRepeat: true };
                                    }}
                                >
                                    {renderTime}
                                </CountdownCircleTimer>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="12">
                            <div className='mt-3 custom-textalign-center'>
                                <Button onClick={paymentAmountContinue}>Confirm Payment Amount and Continue</Button>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    </>;

    const step3 = <>
        <div>
            <div style={{ fontSize: '25px' }}>
                Make a Payment
            </div>
            <hr className='custom-margin-hr'></hr>
            <Row>
                <Col lg="12" className="form-group pr-0 mb-0">
                    <div>
                        <lable>Bank Detail</lable>
                    </div>
                    <Row className="ml-2 p-0">
                        <Col lg="2" className="form-group my-auto pt-2 pl-0 pr-0">
                            <label htmlFor="paymentAmount" className="font-weight-bold">Recipient's Name:</label>
                        </Col>
                        <Col lg="4" className="form-group my-auto d-flex pl-0 pr-0">
                            <span className='p-2'> { bankDetails.recipientName } </span>
                        </Col>

                        <Col lg="2" className="form-group my-auto pt-2 pr-0">
                            <label htmlFor="paymentAmount" className="font-weight-bold">Bank Name:</label>
                        </Col>
                        <Col lg="4" className="form-group my-auto d-flex pl-0 pr-0">
                            <span className='p-2'> { bankDetails.bankName } </span>
                        </Col>
                    </Row>
                    <Row className="ml-2 p-0">
                        <Col lg="2" className="form-group my-auto pt-2 pl-0 pr-0">
                            <label className="font-weight-bold">Recipient Address:</label>
                        </Col>
                        <Col lg="4" className="form-group my-auto d-flex pl-0 pr-0">
                            <span className='p-2'> { bankDetails.address } </span>
                        </Col>

                        <Col lg="2" className="form-group my-auto pt-2 pr-0">
                            <label  className="font-weight-bold">Bank Address:</label>
                        </Col>
                        <Col lg="4" className="form-group my-auto d-flex pl-0 pr-0">
                            <span className='p-2'> { bankDetails.bankAddress } </span>
                        </Col>
                    </Row>
                    <Row className="ml-2 p-0">
                        <Col lg="2" className="form-group my-auto pt-2 pl-0 pr-0">
                            <label  className="font-weight-bold">Bank Account #:</label>
                        </Col>
                        <Col lg="4" className="form-group my-auto d-flex pl-0 pr-0">
                            <span className='p-2'> { bankDetails.bankAccount } </span>
                        </Col>

                        <Col lg="2" className="form-group my-auto pt-2 pr-0">
                            <label className="font-weight-bold">Routing #:</label>
                        </Col>
                        <Col lg="4" className="form-group my-auto d-flex pl-0 pr-0">
                            <span className='p-2'> { bankDetails.routing } </span>
                        </Col>
                    </Row>
                    <Row className="ml-2 p-0">
                        <Col lg="2" className="form-group my-auto pt-2 pl-0 pr-0">
                            <label className="font-weight-bold">Invoice #:</label>
                        </Col>
                        <Col lg="4" className="form-group my-auto d-flex pl-0 pr-0">
                            {/* <span className='p-2'> INV-{refNum} </span> */}
                            <span className='p-2'> INV-{ sessionValue.invoiceRefNum } </span>
                        </Col>

                        <Col lg="2" className="form-group my-auto pt-2 pr-0">
                            <label className="font-weight-bold">Payment Amount:</label>
                        </Col>
                        <Col lg="4" className="form-group my-auto d-flex pl-0 pr-0">
                            <span className='p-2'> {formatNumberAmount(formData.paymentAmount, 'en-US', 2, 2)} {formData.currency} </span>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <hr className='custom-margin-hr'></hr>
            <Row>
                <Col lg="12" className="form-group pl-0 pr-0 mb-0">
                    <div>
                        <lable>Choose Your Payment Method</lable>
                    </div>
                    <Row className="ml-2 p-0">
                        <Col lg="9">
                            <label className="font-weight-bold">
                                Option 1: Bank Transfer - Make a Payment using the steps below:
                            </label>
                        </Col>
                        <Col lg="3" className="pl-0 pr-0">
                            <Link onClick={downloadInstruction}> Download Instruction <i className="fa fa-download"></i></Link>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="12" className="pl-3">
                            <Row className="pl-4"> <span className='fontWeight400 p-1' > Step 1. Log into your normal online or mobile banking </span> </Row>
                            <Row className="pl-4"> <span className='fontWeight400 p-1' > Step 2. Look for option to make a payment or pay a bill </span> </Row>
                            <Row className="pl-4"> <span className='fontWeight400 p-1' > Step 3. Follow the onscreen instruction to enter the banking information </span> </Row>
                            <Row className="pl-4"> <span className='fontWeight400 p-1' > Step 4. Enter the payment amount, currency, date and notes with invoice number </span> </Row>
                            <Row className="pl-4"> <span className='fontWeight400 p-1' > Step 5. Check and confirm - you may need to complete a verification step at this point </span> </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <div class="separator">OR</div>
            <Row>
                <Col lg="12" className="form-group pl-0 pr-0 mb-0">
                    <Row className="ml-2 p-0">
                        <Col lg="9">
                            <label className="font-weight-bold">
                                Option 2: Payment Gateway - Click "Pay Now"
                            </label>
                        </Col>
                        <Col lg="3" className="pl-0 pr-0">
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
        <div>
            <Row>
                <Col lg="12">
                    <Row className="ml-2 p-0">
                        <Col lg="9">

                        </Col>
                        <Col lg="3" className="pl-0 pr-0">
                        </Col>
                    </Row>
                    <div className='mt-3 custom-textalign-center'>
                        <Button onClick={completePayment}>Pay Now</Button>
                    </div>
                </Col>
            </Row>
        </div>
    </>;

    const steps = [
        { label: 'Choose Payment Currency', content: step1, id: 'step1' },
        { label: 'Confirm Payment Amount', content: step2, id: 'step2' },
        { label: 'Make a Payment', content: step3, id: 'step3' },
    ];

    const onCancel = (e) => {
        e.preventDefault();
        //Navigate back to invoice detail page
        history.push({
            pathname: `/client-new-invoices`,
            //state: { refNum: refNum }
            state: { refNum: formData.invoiceRefNum }
        });
        return false;
    }

    useEffect(() => {
        get_client_currency_list();
        get_client_bank_details();
        
        if (refNum === 0) {
            if (location.state !== undefined) {
                //Take from state --> Also Add screnario will fall here
                let passedObj = location.state?.paymentInfo;
                let itemId = passedObj !== undefined ? passedObj.invoiceRefNum : 0;
                let refId = passedObj !== undefined ? passedObj.refNum : 0;
                setrefNum(refId);
                //setrefNum(itemId);
                if (Number(itemId) !== 0) {
                    setSessionValue(passedObj);
                    setFormData({...formData
                        //, currency: passedObj.currency
                        , expiryDate: passedObj.dueDate
                        , balanceDue: passedObj.balanceDue
                        , paymentAmount: passedObj.balanceDue
                        //, fxRate: passedObj?.fxRate
                        , invoiceAmount: passedObj.invoiceAmount
                        , invoiceRefNum: passedObj.invoiceRefNum
                        , refNum: passedObj.refNum
                        //, clientName: passedObj.clientName
                    })
                }
                if(Number(refId) > 0){
                    get_client_invoice_payment(refId);
                    setActiveStep(2);
                }
            }
            else if (localStorage.getItem(NavgationPageLocationKey.clientInvoicePayment) !== null) {
                //Take from local storage 
                let passedObj = localStorage.getItem(NavgationPageLocationKey.clientInvoicePayment);
                //Set state for same page
                const newState = {
                    currency: passedObj.currency
                    , expiryDate: passedObj.dueDate
                    , balanceDue: passedObj.balanceDue
                    , paymentAmount: passedObj.balanceDue
                    //, fxRate: passedObj.fxRate
                    , invoiceAmount: passedObj.invoiceAmount
                    , invoiceRefNum: passedObj.invoiceRefNum
                    , refNum: passedObj.refNum
                }
                history.push(location.pathname, newState);
                localStorage.removeItem(NavgationPageLocationKey.clientInvoicePayment);
            }
        }
        
        return () => {
            reset_client_invoice_payment_details();
        }
    }, [])

    useEffect(() => {
        if(savedInvoicePayment !== undefined && savedInvoicePayment > 0){
            setFormData({ ...formData, refNum: savedInvoicePayment });
        }
    }, [savedInvoicePayment])

    useEffect(() => {
        if(Object.keys(invoicePaymentCalculation).length > 0){
            setFormData({ ...formData
                , fxRate: invoicePaymentCalculation.fxRate
                , expiryDate: invoicePaymentCalculation.expiryDate
                , paymentAmount: invoicePaymentCalculation.paymentAmount
                , balanceDue: invoicePaymentCalculation.paymentAmountInvoiceCurrency
            })
        }
    }, [invoicePaymentCalculation])

    useEffect(() => {
        if(Object.keys(paymentInvoice).length > 0){
            setFormData({ ...formData
                , currency: paymentInvoice.paymentCurrency
                , fxRate: paymentInvoice.fxRate
                , expiryDate: paymentInvoice.expiryDate
                , paymentAmount: paymentInvoice.paymentAmount
                , paymentDate: paymentInvoice.paymentDate
                , refNum: paymentInvoice.refNum
                , invoiceRefNum: paymentInvoice.invoiceRefNum
            })
        }
    }, [paymentInvoice])

    useEffect(() => {
        if(Object.keys(clientBankDetails).length > 0){
            setBankDetails({ ...bankDetails
                , recipientName: decodeURIComponent(clientBankDetails.recipientName)
                , address: decodeURIComponent(clientBankDetails.address)
                , bankName: decodeURIComponent(clientBankDetails.bankName)
                , bankAddress: decodeURIComponent(clientBankDetails.bankAddress)
                , bankAccount: decodeURIComponent(clientBankDetails.bankAccount)
                , routing: decodeURIComponent(clientBankDetails.routing)
            })
        }
    }, [clientBankDetails])

    const redirectToInvoiceNewTab = (e) => {
        e.preventDefault();
        //localStorage.setItem(NavgationPageLocationKey.ClientInvoiceAddEdit, refNum);
        localStorage.setItem(NavgationPageLocationKey.ClientInvoiceAddEdit, formData.invoiceRefNum);
        window.open('/client-new-invoices', '_blank');
    }

    return (<>
        <Container fluid className="main-content-container px-4 pb-4 bg-white mt-2">
            <Card>
                <CardHeader>
                    <div className="page-header tableSearch client_invoice flex-column flex-md-row py-2 d-flex btn-accent">

                        <div className="d-flex align-items-center ml-3 mt-1 mb-1 p-1 bg-white">
                        </div>

                        <div className="form-group pt-2 mb-0 ml-1 col-lg-2 ">
                            <div className='d-flex justify-content-center'>
                                <label> <i> Invoice # </i></label>
                            </div>
                            <div className="d-flex justify-content-center align-items-center p-2" >
                                <div className='invRefBox pl-4 pr-4 pt-2 pb-2' role='button' onClick={redirectToInvoiceNewTab}>
                                    {'INV-' + sessionValue.invoiceRefNum}
                                    <i class="ml-2 fa-solid fa-up-right-from-square"></i>
                                </div>
                            </div>
                        </div>

                        <div className="form-group p-2 mb-0 ml-1 col-lg-3">
                            <div>
                                <label><i>Invoice Amount</i> </label>
                            </div>
                            <div className='pt-2'>
                                <span>{formatNumberAmount(sessionValue.invoiceAmount, 'en-US', 2, 2)} {sessionValue.currency}</span>
                            </div>
                        </div>

                        <div className="form-group p-2 mb-0 ml-1 col-lg-3">
                        </div>

                        <div className="form-group p-2 mb-0 ml-1 col-lg-2 float_right">
                            <div>
                                <label><i>Balance Due</i> </label>
                            </div>
                            <div className='pt-2'>
                                <span>{formatNumberAmount(sessionValue.balanceDue, 'en-US', 2, 2)} {sessionValue.currency}</span>
                            </div>
                        </div>

                        <div className="form-group p-2 mb-0 ml-1 col-lg-2">
                            <div>
                                <label>Due Date </label>
                            </div>
                            <div className='pt-2'>
                                <span>{setDateForTable(sessionValue.dueDate)}</span>
                            </div>
                        </div>
                    </div>
                </CardHeader>
                <CardBody className="paddingtopzero w-100">
                    <Row>
                        <Col lg="11">
                            <div className='custom-stepper p-0'>
                                <CustomVerticalStepper steps={steps} stepActive={activeStep}></CustomVerticalStepper>
                            </div>
                        </Col>
                        <Col lg="1" className="p-0">
                            <Button onClick={onCancel}>Cancel</Button>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </Container>
    </>)
}

const mapStateToProps = (state) => ({
    invoicePaymentCalculation: state.clientInvoice.invoicePaymentCalculation,
    invoiceCurrencyList: state.clientInvoice?.invoiceCurrencyList,
    paymentInvoice: state.clientInvoice?.paymentInvoice,
    savedInvoicePayment: state.clientInvoice?.savedInvoicePayment,

    clientBankDetails: state.clientInvoice?.clientBankDetails,
})
export default connect(mapStateToProps, {
    get_client_currency_list,
    setAlert,
    get_client_calculate_invoice_payment,
    get_client_invoice_payment,
    download_payment_instruction,
    save_client_invoice_payments,
    reset_client_invoice_payment_details,

    get_client_bank_details,

})(ClientPayment)
